/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import { TextField, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import React from 'react';

const EditChat = ({ inputEditRef, newEditName, setNewEditName, modalIsEditOpen, closeEditModal, handleEditSubmit }) => {
  return (   
    <Dialog
      open={modalIsEditOpen}
      onClose={closeEditModal}
      maxWidth="md"
    >
      <DialogTitle>
          Edit Chat Name
      </DialogTitle>
      <DialogContent>
        <TextField 
          id='edit-label'
          label='New Chat name'
          value={newEditName} 
          aria-label='edit-label' 
          ref={inputEditRef} 
          sx={{ width: 300, mt: 2 }}
          onChange={(e) => setNewEditName(e.target.value)} 
          name="currentEditKey"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleEditSubmit} color="primary" variant={'contained'}>
          Update
        </Button>
        <Button onClick={closeEditModal} color="error" variant={'text'}>
          Close
        </Button>
      </DialogActions>
    </Dialog>  
  );
};

export default EditChat;
